module.exports = __webpack_public_path__ + "static/media/fm.1e9bcd1a.svg";